import constants from "./constants";
import * as services from "./services";
import { addToProcess } from "../../base";
import { removeFromProgress } from "../../base/store/actions";

const PAGE_SIZE = 500;

export const getAccountsReceivableForDate = ({
  date,
  creditorId,
  processName,
  errorCallback,
  excludeInvoicesWithPeriodOutsideDate,
}) => {
  return async (dispatch) => {
    try {
      addToProcess(dispatch, constants, processName);

      let allInvoices = [];
      let skip = 0;
      let hasMore = true;

      while (hasMore) {
        const { data } = await services.getAccountsReceivableForDate({
          date,
          creditorId,
          excludeInvoicesWithPeriodOutsideDate,
          skip,
          take: PAGE_SIZE,
        });

        allInvoices = allInvoices.concat(data.InvoiceAccountsReceivable);
        hasMore = data.BatchCount >= PAGE_SIZE;
        skip += PAGE_SIZE;
      }

      dispatch({
        type: constants.SET_ACCOUNTS_RECEIVABLE_BY_DATE,
        payload: {
          creditorId,
          date,
          excludeInvoicesWithPeriodOutsideDate,
          invoices: allInvoices,
        },
      });

      removeFromProgress(dispatch, constants, processName);
    } catch (e) {
      console.log({ e });
      errorCallback && errorCallback(e);
    }
  };
};
